/**
 * All Farm View display helpers (weekly performance units, duration types).
 * Shared by web and mobile farm view / field list UI.
 */

// Irrigation systems whose recommendations/activity are shown as a duration
// (hours) rather than a length amount. Must stay in sync with the backend's
// DURATION_BASED_IRRIGATION_TYPES (FieldManager.py).
var DURATION_BASED_IRRIGATION_TYPES = ['ndrip', 'flood', 'seepage', 'furrow'];

export function isDurationBasedIrrigationType(irrigationType) {
  var typeLower = (irrigationType || '').toLowerCase();
  return DURATION_BASED_IRRIGATION_TYPES.indexOf(typeLower) !== -1;
}

export function normalizeLengthUnitName(unit) {
  var u = (unit || 'mm').toLowerCase();
  if (u === 'in' || u === 'inch' || u === 'inches') {
    return 'inch';
  }
  return 'mm';
}

export function isInchLengthUnit(unit) {
  return normalizeLengthUnitName(unit) === 'inch';
}

export function isHoursUnit(unit) {
  return (unit || '').toLowerCase() === 'hours';
}
